var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('grid', {
    staticClass: "time-grid",
    attrs: {
      "length": _vm.timeValues.length
    }
  }, _vm._l(_vm.timeValues, function (timeValue, index) {
    return _c('div', {
      key: `time-value${index}`,
      staticClass: "time-item",
      style: {
        'grid-row': index + 1
      }
    }, [_c('span', {
      staticClass: "time-item-text"
    }, [_vm._v(" " + _vm._s(timeValue) + " ")])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }